<template>
  <div class="content" v-loading="loading">
    <div class="yxxx-header-wrapper">
       <div class="yxxx-header-wrappers">
          <div class="yxxx-header-content">
            <div class="content-header">
              <div class="name">{{info.major_name}}
              </div>
            </div>
            <div class="content-introduction" v-if="info.major_code" style="margin-top: 22px;">
              <div class="department">
                专业代码：{{info.major_code}}
              </div>
              <div class="department" v-if="info.xiuye_year">
                专业年限：{{info.xiuye_year}}
              </div>
              <div class="department" v-if="info.xuewei">
                授予学位：{{info.xuewei}}
              </div>
              <div class="department" v-if="info.cengci">
                学历层次：{{info.cengci}}
              </div>
            </div>
          </div>
       </div>
    </div>

    <div class="yxxx-content">
       <div class="yxxx-content-left">
         <!--第一印象-->
         <div class="leftTitlt" v-if="info.yinxiang">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           第一印象
         </div>
         <div class="greyBackgroundContainer" v-if="info.yinxiang">
           <div class="greyBackgroundText">
            <p v-html="info.yinxiang || '--'"></p>
           </div>
         </div>
         <!--专业介绍-->
         <div class="leftTitlt" v-if="info.major_info">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           专业介绍
         </div>
         <div class="greyBackgroundContainer" v-if="info.major_info">
           <div class="greyBackgroundText">
            <p v-html="info.major_info || '--'"></p>
           </div>
         </div>

         <!--开设课程-->
         <div class="leftTitlt" v-if="(info.kecheng&&isCha==1)||isCha==0">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           开设课程
         </div>
         <div class="greyBackgroundContainer" v-if="info.kecheng">
           <div class="greyBackgroundText">
            <p v-html="info.kecheng || '--'"></p>
           </div>
         </div>

          <!--续接专业-->
          <div class="leftTitlt" v-if="info.xuejiezy">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           续接专业
         </div>
         <div class="greyBackgroundContainer" v-if="info.xuejiezy">
           <div class="greyBackgroundText">
            <p v-html="info.xuejiezy || '--'"></p>
           </div>
         </div>

          <!--男女比例-->
          <div class="leftTitlt" v-if="info.sexScoe">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           男女比例
         </div>
         <div class="greyBackgroundContainer" v-if="info.sexScoe">
           <div class="greyBackgroundText">
            <p v-html="info.sexScoe || '--'"></p>
           </div>
         </div>

         <!--选考建议-->
         <div class="leftTitlt" v-if="((info.zhuanxian || info.xuekejc || info.xuanke)&&isCha==1)||isCha==0">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           选考建议
         </div>
         <div class="greyBackgroundContainer" v-if="info.zhuanxian || info.xuekejc || info.xuanke">
           <div class="greyBackgroundForm">
             <el-form label-width="110px">
               <el-form-item label="专业限制" v-if="info.zhuanxian">
                  <p v-html="info.zhuanxian || '--'"></p>
               </el-form-item>
               <el-form-item label="学科基础" v-if="info.xuekejc">
                  <p v-html="info.xuekejc || '--'"></p>
               </el-form-item>
               <el-form-item label="选科要求" v-if="info.xuanke">
                  <p v-html="info.xuanke || '--'"></p>
               </el-form-item>
              </el-form>
          </div>
        </div>

        <!--升学方向-->
        <div class="leftTitlt" v-if="((info.yijixueke || info.shuobo)&&isCha==1)||isCha==0">
          <div class="redLine1"></div>
          <div class="redLine2"></div>
          升学方向
        </div>
        <div class="greyBackgroundContainer" v-if="info.yijixueke || info.shuobo">
           <div class="greyBackgroundForm">
             <el-form label-width="110px">
               <el-form-item label="研究生一级学科" v-if="info.yijixueke">
                  <p v-html="info.yijixueke || '--'"></p>
               </el-form-item>
               <el-form-item label="硕博名称" v-if="info.shuobo">
                  <p v-html="info.shuobo || '--'"></p>
               </el-form-item>
              </el-form>
          </div>
        </div>

        <!--就业方向-->
        <div class="leftTitlt" v-if="info.fangxiang">
          <div class="redLine1"></div>
          <div class="redLine2"></div>
          就业方向
        </div>
         <div class="greyBackgroundContainer" v-if="info.fangxiang">
           <div class="greyBackgroundText">
            <p v-html="info.fangxiang || '--'"></p>
           </div>
         </div>


         <!--就业地区分布-->
         <div class="leftTitlt" v-if="info.jiuyefen">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           就业地区分布
         </div>
          <div class="greyBackgroundContainer" v-if="info.jiuyefen">
            <div class="greyBackgroundText">
              <p v-html="info.jiuyefen || '--'"></p>
            </div>
          </div>

          <!--就业行业分布-->
          <div class="leftTitlt" v-if="info.jiuhangye">
            <div class="redLine1"></div>
            <div class="redLine2"></div>
            就业行业分布
          </div>
           <div class="greyBackgroundContainer" v-if="info.jiuhangye">
             <div class="greyBackgroundText">
              <p v-html="info.jiuhangye || '--'"></p>
             </div>
           </div>

           <!--就业岗位分布-->
           <div class="leftTitlt" v-if="info.gangwei">
             <div class="redLine1"></div>
             <div class="redLine2"></div>
             就业岗位分布
           </div>
            <div class="greyBackgroundContainer" v-if="info.gangwei">
              <div class="greyBackgroundText">
                <p v-html="info.gangwei || '--'"></p>
              </div>
            </div>


         <!--详情-->
         <div class="leftTitlt" v-if="info.detail">
           <div class="redLine1"></div>
           <div class="redLine2"></div>
           详情
         </div>
          <div class="greyBackgroundContainer" v-if="info.detail">
            <div class="greyBackgroundText" >
              <p v-html="info.detail || '--'"></p>
            </div>
          </div>

        </div>
    </div>

  </div>
</template>

<script>
  import { Mojor_detail,adminDetail } from "@/api/gw/major.js"
  export default {
    data(){
      return{
         loading:false,
         info:{},
         mojor_id:"",
         major_name:"",
         isAdmin:false,
         isCha:0
      }
    },
    mounted(){
      let mojor_id = this.$route.query.n || null;
      let isAdmin = this.$route.query.i || null;
      this.isCha = this.$route.query.isCha || 0
      this.isAdmin = isAdmin
      if(mojor_id){
         this.mojor_id = mojor_id
         this.Mojor_detail();
      }else{
        this.$message.error("专业不存在");
        this.$router.push({
          path:"/Major"
        })
      }

    },
    methods:{
      replaceNewline(str){
        return str.replace(/\n/g, '<br>');
      },
      Mojor_detail(){
        this.loading = true
        if(this.isAdmin){
          adminDetail({
            mojor_id:this.mojor_id,
            isCha:this.isCha
          }).then(res=>{
             for (let key in res.data) {
              if (typeof res.data[key] === 'string') {
                res.data[key] = res.data[key].replaceAll('\\n', '<br>&nbsp&nbsp&nbsp&nbsp');
              }
            }
            this.info = res.data
          }).finally(()=>{
            this.loading = false
          })
        }else{
          Mojor_detail({
            mojor_id:this.mojor_id,
            isCha:this.isCha
          }).then(res=>{
             for (let key in res.data) {
              if (typeof res.data[key] === 'string') {
                res.data[key] = res.data[key].replaceAll('\\n', '<br>&nbsp&nbsp&nbsp&nbsp');
              }
            }
            this.info = res.data
          }).finally(()=>{
            this.loading = false
          })
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
@import './scss/detail.scss';
.custom-header{
  background: #1CB278!important;
}
p{
  line-height: 28px;
  margin: 2px 3px 0px 5px;
}
  .yxxx-content{
    width: 1250px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 32px;
    .yxxx-content-right{
          width: 372px;
          border-radius: 4px;
    }
    .yxxx-content-left{
      width: 1250px;
      margin: 0 auto;
          background: #fff;
          border-radius: 4px;
          padding: 6px 30px 29px;
    }
  }
  .as{
    background: url(../../assets/yxxx_header_wangzhi.svg) 0 no-repeat!important;
  }
  .asas{
    background: url(../../assets/yxxx_header_dianhua.svg) 0 no-repeat!important;
  }
  .content-info{
    padding-left: 3px;
    .content-info-item{
          padding-left: 23px;
          font-size: 14px;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: url(../../assets/yxxx_header_dizhi.svg) 0 no-repeat;
          margin-bottom: 6px;
      }
  }
  .content-introduction{
    padding-left: 3px;
    margin: 11px 0 16px;
    font-size: 14px;
    display: flex;
    align-items: center;
    .department{
          margin-right: 32px;
          font-size: 24px;
    }
    .content-introduction-item{
          display: inline-block;
          height: 28px;
          line-height: 26px;
          border-radius: 14px;
          border: 1px solid #fff;
          padding: 0 13px;
    }
  }
  .attention{
    display: flex;
    align-items: center;
  }
  .yxxx-header-content{
      width: 526px;
      margin-right: 36px;
      flex: 1;
      color: #fff;
      .content-header{
        height: 36px;
        display: flex;
        align-items: flex-end;
        .name{
          font-size: 38px;
              margin-right: 16px;
              color: #fff;
              font-weight: bold;
              line-height: 1;
        }
      }
  }
  .yxxx-header-img{
      width: 166px;
      height: 166px;
      padding: 15px;
      border-radius: 8px;
      margin-right: 27px;
      background-color: #fff;
      img{
        width: 100%;
        height: 1005;
      }
  }
.yxxx-header-wrapper{
  width: 100%;
  height: 154px;
  background: url(../../assets/yuanxiaoku.jpg) no-repeat 50%,linear-gradient(180deg,#49c48d,#1cb278);
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .yxxx-header-wrappers{
    width: 1250px;
    height: 166px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/major/detail.vue